import axios from 'axios';
import { resetAuthValues, setAccesToken } from './useGetToken';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      try {
        const refreshToken = localStorage.getItem('refreshToken');

        const response = await axios.post(
          `${process.env.REACT_APP_SSO_URL}/v1/auth/token/refresh`,
          { refresh_token: refreshToken },
          {
            headers: {
              'x-public-key': process.env.REACT_APP_SSO_ADMIN_PUBLIC_KEY,
            },
          }
        );

        setAccesToken(response.data.access_token);
        error.config.headers.Authorization = `Bearer ${response.data.access_token}`;
        return axiosInstance(error.config);
      } catch (errorData) {
        console.error('Token refresh failed', errorData);
        resetAuthValues();
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
